// @flow
import * as React from 'react';
import { AgentOutput } from '@coverright/data-access/types/enrollment';
import { useState } from 'react';
import { useInterval } from '../../../../shared';
import { getIsCSR, keycloak } from '@coverright/shared/keycloak';
import { ScheduleACallButton } from '@coverright/features';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { environment } from '../../../../../environments/environment';
import { Button } from '@mui/material';
import moment from 'moment';

type Props = {
  id: string,
  startDate: string,
  onEventScheduled: () => void,
  agent?: AgentOutput,
  client?: {
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
  }
};
export const RescheduleButton = ({id, startDate, onEventScheduled, client, agent}: Props) => {
  const [isBeforeNow, setIsBeforeNow] = useState(isBefore(startDate));
  const isCSR = getIsCSR(keycloak)

  useInterval(() => setIsBeforeNow(isBefore(startDate)), 5000);

  if (isBeforeNow) {
    return <ScheduleACallButton
      variant={'outlined'}
      size={'small'}
      sx={{width: 180}}
      fullWidth
      calendlyProps={{
        dataUrl: environment.production && isCSR ? 'https://calendly.com/coverright-advisors/planning' : undefined,
        agent,
        client,
        onEventScheduled
      }}>
      Schedule new call
    </ScheduleACallButton>
  }

  return <Button sx={{width: 150}} size={'small'}
                 onClick={() => window.open(`https://calendly.com/reschedulings/${id}`)}
                 endIcon={<ArrowSquareOutIcon />}
                 variant={'outlined'}>
    Reschedule
  </Button>
};

const isBefore = (date: string) => moment(date).isBefore(moment());
